export const en = {
  eyebrow: 'AKAS HRIS Pricing 2026',
  title: 'HRMS Pricing Plans',
  description:
    'Choose the HR and payroll package that matches your team size, operational needs, and preferred support level.',
  contactSales: 'Contact Sales',
  backToHrms: 'Back to HRMS',
  popularBadge: 'Advanced',
  standardSectionEyebrow: 'Standard Plan',
  modulesTitle: 'Modules & Features',
  advancedSectionEyebrow: 'Advanced Plan',
  advancedSectionTitle: 'Everything in Standard, plus advanced operations',
  supportEyebrow: 'Support',
  standardSupportTitle: 'Included Standard Support',
  premiumEyebrow: 'Premium Support',
  premiumSupportTitle: '$150 - $250 per month',
  examplesTitle: 'Examples',
  pricingPlans: [
    {
      name: 'Standard Plan',
      description: 'Designed for SMEs looking for a reliable and localized HR & Payroll solution.',
      price: '$1',
      period: 'per employee / month',
      minimum: 'Minimum monthly fee: $50',
      setup: 'One-time setup fee: $300 - $500',
      highlight: false,
    },
    {
      name: 'Advanced Plan',
      description: 'Designed for growing businesses and enterprises requiring advanced HR operations and process automation.',
      price: '$2',
      period: 'per employee / month',
      minimum: 'Minimum monthly fee: $100',
      setup: 'One-time setup fee: $600 - $1,000',
      highlight: true,
    },
  ],
  standardFeatureGroups: [
    {
      title: 'Core HR',
      features: [
        'Personnel Management',
        'Employee Profile & Document Management',
        'Organizational Chart',
        'Multi-branch & Department Structure',
        'Multi-currency Support and exchange rate: Transactions, Salary Tax, NSSF',
      ],
    },
    {
      title: 'Workforce Management',
      features: [
        'Attendance Management',
        'Shift & Schedule Management',
        'Leave & Holiday Management',
        'Overtime Tracking',
      ],
    },
    {
      title: 'Payroll',
      features: [
        'Payroll Processing',
        'NSSF Contribution Management',
        'Pension Fund Calculation',
        'Allowance & Deduction Management',
        'Khmer & English Payslip',
      ],
    },
    {
      title: 'Workflow & Automation',
      features: [
        'Approval Workflows',
        'Notifications & Alerts',
        'Employee Self-Service',
      ],
    },
    {
      title: 'Reporting & Customization',
      features: [
        'Forms Customization',
        'Reports Customization',
        'Export to Excel/PDF',
      ],
    },
    {
      title: 'Standard Support',
      features: ['Included for free'],
    },
  ],
  advancedFeatureGroups: [
    {
      title: 'Talent Acquisition',
      features: [
        'Recruitment Management',
        'Job Vacancy Tracking',
        'Candidate Pipeline',
        'Interview Scheduling',
        'Applicant Database',
      ],
    },
    {
      title: 'Performance Management',
      features: [
        'Performance Review System',
        'KPI & Goal Tracking',
        'Manager & Employee Assessments - Multiple lines of reviewer (360)',
      ],
    },
    {
      title: 'Flex List (Dynamic Business Process Module)',
      description: 'Empower users to build their own operational workflows without development.',
      features: [
        'Custom List Builder',
        'Dynamic Form Creation',
        'Approval Flow Configuration',
        'Status Tracking',
        'Custom Fields',
        'Role-based Access',
        'Workflow Notifications',
      ],
      examples: [
        'Purchase Requests',
        'Asset Requests',
        'Travel Requests',
        'Expense Claims',
        'Internal Approval Processes',
      ],
    },
  ],
  standardSupportGroups: [
    {
      title: 'System Maintenance',
      features: [
        'Bug fixes',
        'Minor issue troubleshooting',
        'Performance monitoring',
        'Database maintenance',
        'Backup verification',
      ],
    },
    {
      title: 'User Support',
      features: [
        'Email support',
        'Telegram/Chat support during office hours',
        'Basic user guidance',
        'Password reset assistance',
        'User access troubleshooting',
        'Attendance sync troubleshooting',
      ],
    },
    {
      title: 'Functional Assistance',
      features: [
        'Payroll calculation issue checking',
        'Leave balance issue checking',
        'Attendance discrepancy review',
        'Report troubleshooting',
        'Basic workflow configuration help',
      ],
    },
    {
      title: 'Updates',
      features: [
        'Standard product updates',
        'Regulatory updates (Cambodia labor/payslip/tax related)',
        'Minor UI improvements',
        'Compatibility updates',
      ],
    },
  ],
  premiumSupportGroups: [
    {
      title: 'Priority Technical Support',
      features: [
        'Priority bug fixing queue',
        'Faster incident response',
        'Emergency support',
        'After-hours support',
        'Weekend support',
        'Hotline support',
        'Dedicated account manager',
      ],
    },
    {
      title: 'Advanced Troubleshooting',
      features: [
        'Payroll emergency handling',
        'Attendance device integration troubleshooting',
        'API troubleshooting',
        'Performance optimization',
        'Server resource analysis',
      ],
    },
    {
      title: 'Customization Support',
      features: [
        'Small feature enhancements',
        'Custom report creation',
        'Workflow adjustments',
        'Approval flow modifications',
        'Custom field configuration',
        'Template modifications',
        'HR policy configuration assistance',
      ],
    },
    {
      title: 'Business & Operational Support',
      features: [
        'Monthly system health review',
        'Usage analytics review',
        'HR process consultation',
        'Payroll process optimization',
        'Compliance advisory',
        'Best-practice recommendations',
      ],
    },
    {
      title: 'Advanced Operational Services',
      features: [
        'Disaster recovery assistance',
        'Priority backup restoration',
        'Data migration assistance',
        'Integration monitoring',
        'Server monitoring',
        'Scheduled maintenance coordination',
      ],
    },
  ],
};

export type Copy = typeof en;

export const km: Copy = {
  eyebrow: 'តម្លៃ AKAS HRIS ឆ្នាំ 2026',
  title: 'ផែនការតម្លៃ HRMS',
  description:
    'ជ្រើសរើសកញ្ចប់ធនធានមនុស្ស និងការគណនាប្រាក់ខែដែលសមស្របនឹងទំហំក្រុមការងារ តម្រូវការប្រតិបត្តិការ និងកម្រិតជំនួយដែលអ្នកចង់បាន។',
  contactSales: 'ទំនាក់ទំនងផ្នែកលក់',
  backToHrms: 'ត្រឡប់ទៅ HRMS',
  popularBadge: 'កម្រិតខ្ពស់',
  standardSectionEyebrow: 'ផែនការស្តង់ដារ',
  modulesTitle: 'ម៉ូឌុល និងលក្ខណៈពិសេស',
  advancedSectionEyebrow: 'ផែនការកម្រិតខ្ពស់',
  advancedSectionTitle: 'អ្វីៗទាំងអស់ក្នុងផែនការស្តង់ដារ បូករួមជាមួយប្រតិបត្តិការកម្រិតខ្ពស់',
  supportEyebrow: 'ជំនួយ',
  standardSupportTitle: 'ជំនួយស្តង់ដារដែលរួមបញ្ចូល',
  premiumEyebrow: 'ជំនួយកម្រិត Premium',
  premiumSupportTitle: '$150 - $250 ក្នុងមួយខែ',
  examplesTitle: 'ឧទាហរណ៍',
  pricingPlans: [
    {
      name: 'ផែនការស្តង់ដារ',
      description: 'រៀបចំឡើងសម្រាប់សហគ្រាសខ្នាតតូច និងមធ្យមដែលកំពុងស្វែងរកដំណោះស្រាយធនធានមនុស្ស និងប្រាក់ខែដែលអាចទុកចិត្តបាន និងសមនឹងកម្ពុជា។',
      price: '$1',
      period: 'ក្នុងមួយបុគ្គលិក / ខែ',
      minimum: 'ថ្លៃប្រចាំខែអប្បបរមា៖ $50',
      setup: 'ថ្លៃដំឡើងគ្រាដើម៖ $300 - $500',
      highlight: false,
    },
    {
      name: 'ផែនការកម្រិតខ្ពស់',
      description: 'រៀបចំឡើងសម្រាប់អាជីវកម្មដែលកំពុងរីកចម្រើន និងស្ថាប័នធំៗ ដែលត្រូវការប្រតិបត្តិការធនធានមនុស្ស កម្រិតខ្ពស់ និង Automation នៃដំណើរការ។',
      price: '$2',
      period: 'ក្នុងមួយបុគ្គលិក / ខែ',
      minimum: 'ថ្លៃប្រចាំខែអប្បបរមា៖ $100',
      setup: 'ថ្លៃដំឡើងគ្រាដើម៖ $600 - $1,000',
      highlight: true,
    },
  ],
  standardFeatureGroups: [
    {
      title: 'ធនធានមនុស្ស ស្នូល',
      features: [
        'ការគ្រប់គ្រងបុគ្គលិក',
        'ការគ្រប់គ្រងប្រវត្តិរូបបុគ្គលិក និងឯកសារ',
        'តារាងរចនាសម្ព័ន្ធស្ថាប័ន',
        'រចនាសម្ព័ន្ធសាខា និងនាយកដ្ឋានច្រើន',
        'គាំទ្ររូបិយប័ណ្ណច្រើន និងអត្រាប្តូរប្រាក់៖ ប្រតិបត្តិការ ពន្ធលើប្រាក់ខែ NSSF',
      ],
    },
    {
      title: 'ការគ្រប់គ្រងកម្លាំងពលកម្ម',
      features: [
        'ការគ្រប់គ្រងវត្តមានធ្វើការ',
        'ការគ្រប់គ្រងវេន និងកាលវិភាគ',
        'ការគ្រប់គ្រងការឈប់សម្រាក និងថ្ងៃបុណ្យ',
        'ការតាមដានម៉ោងធ្វើការលើស',
      ],
    },
    {
      title: 'ប្រាក់ខែ (Payroll)',
      features: [
        'ដំណើរការគណនាប្រាក់ខែ',
        'ការគ្រប់គ្រងការចូលវិភាគទាន NSSF',
        'ការគណនាមូលនិធិចូលនិវត្តន៍',
        'ការគ្រប់គ្រងប្រាក់ឧបត្ថម្ភ និងការកាត់ប្រាក់',
        'បង្កាន់ដៃប្រាក់ខែជាភាសាខ្មែរ និងអង់គ្លេស',
      ],
    },
    {
      title: 'Workflow និង Automation',
      features: [
        'Workflow នៃការអនុម័ត',
        'ការជូនដំណឹង និងការព្រមាន',
        'សេវាខ្លួនឯងសម្រាប់បុគ្គលិក',
      ],
    },
    {
      title: 'របាយការណ៍ និងការប្ដូរតាមត្រូវការ',
      features: [
        'ការប្ដូរទម្រង់តាមត្រូវការ',
        'ការប្ដូររបាយការណ៍តាមត្រូវការ',
        'នាំចេញជា Excel/PDF',
      ],
    },
    {
      title: 'ជំនួយស្តង់ដារ',
      features: ['រួមបញ្ចូលដោយឥតគិតថ្លៃ'],
    },
  ],
  advancedFeatureGroups: [
    {
      title: 'ការទាញយកទេពកោសល្យ',
      features: [
        'ការគ្រប់គ្រងការជ្រើសរើសបុគ្គលិក',
        'ការតាមដានកន្លែងធ្វើការទំនេរ',
        'ដំណើរការបេក្ខជន',
        'ការរៀបចំកាលវិភាគសម្ភាសន៍',
        'មូលដ្ឋានទិន្នន័យអ្នកដាក់ពាក្យ',
      ],
    },
    {
      title: 'ការគ្រប់គ្រងលទ្ធផលការងារ',
      features: [
        'ប្រព័ន្ធវាយតម្លៃលទ្ធផលការងារ',
        'ការតាមដាន KPI និងគោលដៅ',
        'ការវាយតម្លៃដោយអ្នកគ្រប់គ្រង និងបុគ្គលិក - អ្នកវាយតម្លៃច្រើនជាន់ (360)',
      ],
    },
    {
      title: 'Flex List (ម៉ូឌុលដំណើរការអាជីវកម្មដែលអាចកំណត់បាន)',
      description: 'ឱ្យអ្នកប្រើប្រាស់បង្កើតលំហូរការងារប្រតិបត្តិការផ្ទាល់ខ្លួន ដោយមិនចាំបាច់អភិវឌ្ឍន៍កម្មវិធី។',
      features: [
        'ឧបករណ៍បង្កើតបញ្ជីផ្ទាល់ខ្លួន',
        'ការបង្កើតទម្រង់ Dynamic',
        'ការរៀបចំលំហូរការអនុម័ត',
        'ការតាមដានស្ថានភាព',
        'វាលទិន្នន័យផ្ទាល់ខ្លួន',
        'សិទ្ធិចូលប្រើតាមតួនាទី',
        'ការជូនដំណឹងនៃ Workflow',
      ],
      examples: [
        'សំណើសុំទិញ',
        'សំណើសុំទ្រព្យសម្បត្តិ',
        'សំណើសុំធ្វើដំណើរ',
        'សំណើសុំលុយចំណាយ',
        'ដំណើរការអនុម័តខាងក្នុង',
      ],
    },
  ],
  standardSupportGroups: [
    {
      title: 'ការថែទាំប្រព័ន្ធ',
      features: [
        'ការជួសជុល Bug',
        'ការដោះស្រាយបញ្ហាតូចតាច',
        'ការត្រួតពិនិត្យសមត្ថភាពដំណើរការ',
        'ការថែទាំមូលដ្ឋានទិន្នន័យ',
        'ការផ្ទៀងផ្ទាត់ Backup',
      ],
    },
    {
      title: 'ជំនួយអ្នកប្រើប្រាស់',
      features: [
        'ជំនួយតាមអ៊ីមែល',
        'ជំនួយតាម Telegram/Chat ក្នុងម៉ោងធ្វើការ',
        'ការណែនាំមូលដ្ឋានដល់អ្នកប្រើប្រាស់',
        'ជំនួយក្នុងការកំណត់ពាក្យសម្ងាត់ឡើងវិញ',
        'ការដោះស្រាយបញ្ហាការចូលប្រើរបស់អ្នកប្រើប្រាស់',
        'ការដោះស្រាយបញ្ហា Sync វត្តមាន',
      ],
    },
    {
      title: 'ជំនួយផ្នែកមុខងារ',
      features: [
        'ការពិនិត្យបញ្ហាការគណនាប្រាក់ខែ',
        'ការពិនិត្យបញ្ហាចំនួនថ្ងៃឈប់សម្រាក',
        'ការពិនិត្យភាពខុសគ្នានៃវត្តមាន',
        'ការដោះស្រាយបញ្ហារបាយការណ៍',
        'ជំនួយក្នុងការរៀបចំ Workflow មូលដ្ឋាន',
      ],
    },
    {
      title: 'ការធ្វើឱ្យទាន់សម័យ',
      features: [
        'ការធ្វើឱ្យទាន់សម័យផលិតផលស្តង់ដារ',
        'ការធ្វើឱ្យទាន់សម័យតាមបទប្បញ្ញត្តិ (ពាក់ព័ន្ធច្បាប់ការងារ ស្លឹកប្រាក់ខែ និងពន្ធនៅកម្ពុជា)',
        'ការកែលម្អ UI តូចៗ',
        'ការធ្វើឱ្យទាន់សម័យភាពឆបគ្នា',
      ],
    },
  ],
  premiumSupportGroups: [
    {
      title: 'ជំនួយបច្ចេកទេសអាទិភាព',
      features: [
        'ជួរជួសជុល Bug តាមអាទិភាព',
        'ការឆ្លើយតបបញ្ហាលឿនជាងមុន',
        'ជំនួយពេលអាសន្ន',
        'ជំនួយក្រៅម៉ោងធ្វើការ',
        'ជំនួយថ្ងៃចុងសប្តាហ៍',
        'ជំនួយតាម Hotline',
        'អ្នកទទួលបន្ទុកគណនីដាច់ដោយឡែក',
      ],
    },
    {
      title: 'ការដោះស្រាយបញ្ហាកម្រិតខ្ពស់',
      features: [
        'ការដោះស្រាយបញ្ហាប្រាក់ខែពេលអាសន្ន',
        'ការដោះស្រាយបញ្ហាការតភ្ជាប់ឧបករណ៍វត្តមាន',
        'ការដោះស្រាយបញ្ហា API',
        'ការកែសម្រួល Performance',
        'ការវិភាគធនធាន Server',
      ],
    },
    {
      title: 'ជំនួយការប្ដូរតាមត្រូវការ',
      features: [
        'ការកែលម្អមុខងារតូចៗ',
        'ការបង្កើតរបាយការណ៍ផ្ទាល់ខ្លួន',
        'ការកែតម្រូវ Workflow',
        'ការកែប្រែលំហូរការអនុម័ត',
        'ការរៀបចំវាលទិន្នន័យផ្ទាល់ខ្លួន',
        'ការកែប្រែ Template',
        'ជំនួយក្នុងការរៀបចំគោលការណ៍ធនធានមនុស្ស',
      ],
    },
    {
      title: 'ជំនួយអាជីវកម្ម និងប្រតិបត្តិការ',
      features: [
        'ការពិនិត្យសុខភាពប្រព័ន្ធប្រចាំខែ',
        'ការពិនិត្យការវិភាគការប្រើប្រាស់',
        'ការប្រឹក្សាដំណើរការធនធានមនុស្ស',
        'ការធ្វើឱ្យដំណើរការប្រាក់ខែប្រសើរឡើង',
        'ការប្រឹក្សាអំពីការអនុលោមតាមច្បាប់',
        'អនុសាសន៍វិធីអនុវត្តល្អបំផុត',
      ],
    },
    {
      title: 'សេវាប្រតិបត្តិការកម្រិតខ្ពស់',
      features: [
        'ជំនួយស្ដារឡើងវិញពេលមានគ្រោះថ្នាក់',
        'ការស្ដារ Backup ឡើងវិញតាមអាទិភាព',
        'ជំនួយក្នុងការបញ្ជូនទិន្នន័យ',
        'ការត្រួតពិនិត្យ Integration',
        'ការត្រួតពិនិត្យ Server',
        'ការសម្របសម្រួលការថែទាំតាមកាលវិភាគ',
      ],
    },
  ],
};
